import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { Carousel } from "primeng/carousel";
import { HelpDialogItem, HelpDialogUpdate } from "ng/src/app/core/help-dialog/help-dialog.model";
import { HelpDialogService } from "ng/src/app/core/help-dialog/help-dialog.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
	selector: 'lb-help-dialog',
	template: `
		<div>
			<p-dialog styleClass="help-dialog" appendTo="body" [(visible)]="visible"
			          [position]="$any(position)" [resizable]="false" [modal]="true"
			          [draggable]="false" [style]="{ width: '750px' }">
				<p-carousel #carousel [value]="items" [circular]="false" [showIndicators]="items.length > 1" [showNavigators]="items.length > 1">
					<ng-template let-item pTemplate="item">
						
						<div class="help-dialog-content p-d-flex p-flex-column" style="height: 100%">
							<div *ngIf="item.header" class="title p-text-center">
								{{item.header}}
                                <p-divider></p-divider>
							</div>
							<div *ngIf="item.pictureUrl" class="p-text-center">
								<img alt="" [src]="item.pictureUrl" style="max-width: 95%; filter: grayscale(30%)">
                                <p-divider></p-divider>
							</div>
							
							<div style="flex-grow: 1">
								<div *ngIf="!item.baseIsTemplateRef(); else templateTextBase" class="whitespace-pre-line">
									{{item.base}}
								</div>
								<ng-template #templateTextBase>
									<ng-container [ngTemplateOutlet]="item.base"></ng-container>
								</ng-template>
							</div>
							
							<div *ngIf="item.detailLink" class="p-mb-1 p-text-center">
								<p-divider></p-divider>
                                <a class="detail-link"
                                   pButton
                                   target="_blank"
                                   [href]="item.detailLinkIsString() ? item.detailLink : item.detailLink.link"
                                   [label]="(!item.detailLinkIsString()) ? item.detailLink.text : 'More Info'">
                                </a>
							</div>
						</div>
						
					</ng-template>
				</p-carousel>
			</p-dialog>
		</div>
	`,
	styleUrls: ['./help-dialog.component.scss']
})
export class HelpDialogComponent implements OnInit, OnDestroy {
	@ViewChild('carousel') carousel!: Carousel;
	
	@Input()
	items = new Array<HelpDialogItem>();
	
	@Input()
	get visible() {
		return this._visible;
	}
	set visible(val) {
		this._visible = val;
		this.visibleChange.next(val);
	}
	
	@Input()
	get index() {
		return this._index;
	}
	set index(val) {
		this._index = val < 0
			? 0
			: val >= this.items.length
				? this.items.length - 1
				: val;
		
		if (this.carousel && this.carousel.page !== val) {
			this.carousel.page = val;
		}
		
		this.indexChange.next(this._index);
	}
	
	@Input()
	position: HelpDialogUpdate['position'] = 'top';
	
	@Output()
	indexChange = new EventEmitter<number>();
	
	@Output()
	visibleChange = new EventEmitter<boolean>();
	
	private _index = 0;
	private _visible = false;
	private onDestroySubject = new Subject();
	
	constructor(
		private readonly helpDialogService: HelpDialogService
	) {}
	
	ngOnInit(): void {
		this.helpDialogService.next$.pipe(
			takeUntil(this.onDestroySubject)
		)
			.subscribe((val) => {
				if (!val) {
					this.reset();
					return;
				}
				
				this.items = val.items;
				this.index = typeof val.index === 'number' ? val.index : 0;
				this.visible = true;
				this.position = val.position ?? 'top';
			})
	}
	
	ngOnDestroy(): void {
		this.onDestroySubject.next();
	}
	
	@HostListener('document:keydown', ['$event'])
	keypress(event: KeyboardEvent) {
		if (!this.visible || !this.carousel) return;
		
		if (event.key === 'ArrowLeft' && this.carousel.page > 0) {
			this.carousel.page = this.carousel.page - 1;
		}
		else if (event.key === 'ArrowRight' && this.carousel.page < this.items.length - 1) {
			this.carousel.page = this.carousel.page + 1;
		}
	}
	
	reset() {
		this.items = [];
		this.index = 0;
	}
}

